import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { filter } from 'lodash';

import { useStores } from '@/hooks/use-stores';
import SeverityIcon from '@/comp/common/icons/SeverityIcon';
import { AlertLevels, AlertStatus } from '@/constants/enums';

export const AlertsWidget = observer(({ alerts = [], ...rest }) => {
  const { alertStore } = useStores();
  const openAlerts = filter(alerts, { status: AlertStatus.Open }) || [];
  const activeAlerts = alertStore.filterActiveAlerts(openAlerts);

  const getSeverityName = () => {
    const warning = filter(activeAlerts, { severity: AlertLevels.Warning });
    const shutdown = filter(activeAlerts, { severity: AlertLevels.Shutdown });
    const service = filter(activeAlerts, { severity: AlertLevels.Service });
    const masterArray = [...shutdown, ...warning, ...service];

    if (masterArray.length === 0) return;

    return masterArray[0].severity;
  };

  const getSeverityLength = () => {
    return filter(activeAlerts, { severity: getSeverityName() }).length;
  };

  const length = getSeverityLength();

  return (
    <Container {...rest} $shouldHide={!length}>
      <span className="icon">
        <SeverityIcon severity={getSeverityName()} />
      </span>
      <span className="label">{length}</span>
    </Container>
  );
});

const Container = styled.div<{ $shouldHide: boolean }>`
  display: inline-flex;
  height: 16px;

  ${({ $shouldHide }) => $shouldHide && 'visibility: hidden;'}

  .label {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 16px;
    padding: 0 ${({ theme: { token } }) => token.paddingXXS}px;
    border-radius: 0 1px 1px 0;
    font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
    color: ${({ theme: { token } }) => token.colorText};
    background-color: ${({ theme: { token } }) => token.colorBgElevated};
  }
`;
